
    import BookableItems from "./components/BookableItems.vue";

    export default {
        name: "Bookables",
        components: {
            BookableItems
        }
    };
